import { format, FORMAT } from "commons/src/NuDateUtils";

export function generateFilename(clientName, accountNum, startDate, endDate, extension) {
    const filenameParts = [
        accountNum,
        format(startDate, FORMAT.DASH_SEPARATED),
        format(endDate, FORMAT.DASH_SEPARATED)
    ];
    if (clientName) {
        filenameParts.unshift(clientName);
    }
    return filenameParts.join(" - ") + extension;
}
